import type { InboxStudioMessage } from '../lib/inboxStudioMessages'

type Props = {
  message: InboxStudioMessage
  onClose: () => void
}

const toneClass: Record<InboxStudioMessage['tone'], string> = {
  neutral: 'at-inbox-modal-tone-neutral',
  warning: 'at-inbox-modal-tone-warning',
  danger: 'at-inbox-modal-tone-danger',
  success: 'at-inbox-modal-tone-success',
  info: 'at-inbox-modal-tone-info',
  purple: 'at-inbox-modal-tone-purple',
}

export default function InboxStudioModal({ message, onClose }: Props) {
  const dateLabel = message.date
    ? message.date.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })
    : '—'

  return (
    <div className="at-inbox-modal-backdrop" onClick={onClose} role="presentation">
      <div
        className="at-inbox-modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-labelledby="at-inbox-modal-subject"
      >
        <header className="at-inbox-modal-head">
          <div>
            <p className="at-inbox-modal-from">TraderHub24</p>
            <h2 id="at-inbox-modal-subject">{message.subject}</h2>
            <p className="at-inbox-modal-meta">
              <span className={toneClass[message.tone]}>{message.category}</span>
              <time>{dateLabel}</time>
            </p>
          </div>
          <button type="button" className="at-inbox-modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </header>
        <div className="at-inbox-modal-body">
          <p>{message.body}</p>
        </div>
        {message.actions.length > 0 && (
          <footer className="at-inbox-modal-foot">
            {message.actions.map((action) => (
              <button
                key={action.label}
                type="button"
                className={action.primary ? 'at-inbox-modal-primary' : 'at-inbox-modal-secondary'}
                onClick={() => {
                  action.onClick()
                  onClose()
                }}
              >
                {action.label}
              </button>
            ))}
          </footer>
        )}
      </div>
    </div>
  )
}
